// extracted by mini-css-extract-plugin
module.exports = {"diff-viewer-container":"DiffViewer_diff-viewer-container__njDCh"};